:root {
  --imposter-margin: 3.5rem;
  --admin-margin: 3.5rem;

  /* Background, borders & primary colours */
  --light-gray: #f3f3f3;
  --border-gray: #777;
  --blue-primary: #3961ca;
  --icon-gray: #666666;

  --active-green: #05C525;
  --black-70: rgba(0,0,0,0.7);
  --white-90: rgba(255,255,255, 0.87);

  /* Dark mode (starts with dm-) */
  --dm-background: #121212;

  /* Input vars */
  --input-border: rgba(34,36,38,.15);
  --input-focus-placeholder: #4e4e4e;

  /* Buttons */
  --background-dark-gray: #41484d;

  /* Error colours */
  --error-border: #FF0000;

  --drop-zone-border: #3961ca;
  --drop-zone-bg: #3962ca46;

  /* Modal vars */

  --modal-bg: #f0f0f0;
  --modal-header: #FDFBF8;
}

img {
  border:0;
}

.cms-icon {
  font-family: "Material Icons";
}

.cms-icon:focus {
  outline: none;
}

button.cms-icon {
  background: none;
  border: none;
  font-size: 1.4rem;
  cursor: pointer;
  color: var(--icon-gray);
}

.cms-checkbox input[type=checkbox] + label {
  display: flex;
  align-items: center;
  margin: 0.2em;
  cursor: pointer;
  padding: 0.2em;
}

.cms-checkbox input[type=checkbox] + label:before {
  content: "\2714";
  border: 0.1em solid #000;
  border-radius: 0.2em;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  margin-right: 0.2em;
  color: transparent;
  transition: .2s;
}

.cms-checkbox input[type=checkbox] + label:active:before {
  transform: scale(0);
}

.cms-checkbox input[type=checkbox]:checked + label:before {
  background-color: var(--blue-primary);
  border-color: var(--blue-primary);
  color: #fff;
}

.cms-checkbox input[type=checkbox] {
  display: none;
}

.btn {
  padding: 10px 15px;
  border: none;
  background: var(--background-dark-gray);
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}

img {
  border:0;
}

.cms-imposter-margin {
  margin-top: var(--imposter-margin);
}

.cms-admin-margin {
  margin-top: var(--admin-margin);
}

.cms-sidebar-margin {
  margin-left: var(--admin-margin);
}

.cms-imposter-margin.cms-admin-margin {
  margin-top: calc(var(--imposter-margin) + var(--admin-margin));
}
